import * as React from 'react';

import Avatar, { AvatarItem } from '@atlaskit/avatar';
import { Link } from 'react-resource-router';
import styled from 'styled-components';

import { BannerAnnouncement } from './Banner';
import { Container } from './Container';
import cookiesLover from '../assets/cookies-lover.gif';
import recipesCookies1 from '../assets/recipes-cookies-1.jpeg';
import recipesCookies2 from '../assets/recipes-cookies-2.jpeg';
import recipesCookies3 from '../assets/recipes-cookies-3.jpeg';
import recipesCookies4 from '../assets/recipes-cookies-4.jpeg';
import recipesCookies5 from '../assets/recipes-cookies-5.jpeg';
import '../css/home.css';

const Wrapper = styled.div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;

export const Home = (): JSX.Element => {
  return (
    <Container>
      <BannerAnnouncement />
      <br />
      <Wrapper>
        <h2>How to bake your cookies</h2>
        <div>
          <AvatarItem
            avatar={<Avatar presence="online" label="Jack (online)" />}
            primaryText="Jack"
          />
        </div>
        <div className="banner">
          <img src={cookiesLover} alt="Cookie Lover" />
        </div>
        <div className="recipeIngredients">
          <h2>Ingredients</h2>
          <div className="rdpIngredients">
            <ul>
              <li className="ingredient">
                <span className="quantity">2 1/4</span>
                <span className="unitOfMeasure" />
                <span className="description">
                  cups Gold Medal™ all-purpose flour
                </span>
              </li>
              <li className="ingredient">
                <span className="quantity">1</span>
                <span className="unitOfMeasure">teaspoon</span>
                <span className="description">baking soda</span>
              </li>
              <li className="ingredient">
                <span className="quantity">1/2</span>
                <span className="unitOfMeasure">teaspoon</span>
                <span className="description">salt</span>
              </li>
              <li className="ingredient">
                <span className="quantity">1</span>
                <span className="unitOfMeasure">cup</span>
                <span className="description">butter, softened </span>
              </li>
              <li className="ingredient">
                <span className="quantity">3/4</span>
                <span className="unitOfMeasure">cup</span>
                <span className="description">granulated sugar </span>
              </li>
              <li className="ingredient">
                <span className="quantity">3/4</span>
                <span className="unitOfMeasure">cup</span>
                <span className="description">packed brown sugar </span>
              </li>
              <li className="ingredient">
                <span className="quantity">1</span>
                <span className="unitOfMeasure" />
                <span className="description">egg </span>
              </li>
              <li className="ingredient">
                <span className="quantity">1</span>
                <span className="unitOfMeasure">teaspoon</span>
                <span className="description">vanilla </span>
              </li>
              <li className="ingredient">
                <span className="quantity">2</span>
                <span className="unitOfMeasure">cups</span>
                <span className="description">semisweet chocolate chips </span>
              </li>
              <li className="ingredient">
                <span className="quantity">1</span>
                <span className="unitOfMeasure">cup</span>
                <span className="description">
                  coarsely chopped nuts, if desired
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="rdpSteps">
          <h2>Steps</h2>

          <ul className="recipeSteps">
            <li className="recipeStep">
              <div className="stepDescription">
                1. Heat oven to 375°F. In small bowl, mix flour, baking soda and
                salt; set aside.
                <div className="stepShotContainer">
                  <img
                    className="lazyImage"
                    src={recipesCookies1}
                    alt="Step 1"
                  />
                </div>
              </div>
            </li>{' '}
            <li className="recipeStep">
              <div className="stepDescription">
                2.In large bowl, beat softened butter and sugars with electric
                mixer on medium speed, or mix with spoon about 1 minute or until
                fluffy, scraping side of bowl occasionally.
                <div className="stepShotContainer">
                  <img
                    className="lazyImage"
                    src={recipesCookies2}
                    alt="Step 2"
                  />
                </div>
              </div>
            </li>{' '}
            <li className="recipeStep">
              <div className="stepDescription">
                3. Beat in egg and vanilla until smooth. Stir in flour mixture
                just until blended (dough will be stiff). Stir in chocolate
                chips and nuts.
                <div className="stepShotContainer">
                  <img
                    className="lazyImage"
                    src={recipesCookies3}
                    alt="Step 3"
                  />
                </div>
              </div>
            </li>{' '}
            <li className="recipeStep">
              <div className="stepDescription">
                4. Onto ungreased cookie sheets, drop dough by rounded
                tablespoonfuls 2 inches apart.
                <div className="stepShotContainer">
                  <img
                    className="lazyImage"
                    src={recipesCookies4}
                    alt="Step 4"
                  />
                </div>
              </div>
            </li>{' '}
            <li className="recipeStep">
              <div className="stepDescription">
                5. Bake 8 to 10 minutes or until light brown (centers will be
                soft). Cool 2 minutes; remove from cookie sheet to cooling rack.
                Cool completely, about 30 minutes. Store covered in airtight
                container.
                <div className="stepShotContainer">
                  <img
                    className="lazyImage"
                    src={recipesCookies5}
                    alt="Step 5"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <br />
        <Link to="/about">About the Cookies History</Link>
      </Wrapper>
    </Container>
  );
};
